import React from 'react';
import Image from 'next/image';

const PostModal = ({ post, closePost }) => {
  if (!post) return null;

  return (
    <div className='absolute sm:px-vw-7 sm:py-vw-14 top-0 left-0 sm:backdrop-blur-sm sm:backdrop-opacity-90 bg-gray/75'>
      <div className="modal-body bg-white px-4 py-8 sm:px-18 sm:py-24 relative flex flex-col">
        <button className='absolute top-6 right-4 flex gap-1 items-center cursor-pointer sm:text-vw-xl text-vw-3xl text-primary hover:underline' onClick={closePost}>
          <svg width="1em" height="auto" viewBox="0 0 330 330" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393  c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393  s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z" fill="#0047FF"></path></svg>
          back
        </button>
        <h2 className='post-modal-title sm:text-vw-5xl text-vw-6xl font-bold mb-6 sm:mb-10 sm:order-2'>{post.title}</h2>
        {post.featuredImage && (
        <div>
          <Image className='post-modal-image mb-10 sm:mb-20 sm:order-1 max-w-full'
            src={post.featuredImage.src}
            alt={post.title}
            width={1920}
            height={1080}
            style={{objectFit: "contain"}}
            quality={70}
            placeholder={post.featuredImage.blurDataURL ? "blur" : "empty"}
            blurDataURL={post.featuredImage.blurDataURL? post.featuredImage.blurDataURL : undefined}
            />
        </div>)}
        <div className='post-modal-content sm:order-3 text-vw-5xl sm:text-vw-2xl' dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </div>
  );
};

export default PostModal;